<template>
  <div class="resizer" :style="{ zIndex: isActive ? 20000 : 0, cursor: cursor }" @mousedown="elementDown">
    <div v-for="handle in handles" v-show="isActive" :class="['handle', 'handle-' + handle]"
         @mousedown.stop.prevent="handleDown(handle, $event)">
    </div>
    <slot name="menu" v-if="isActive" :style="{ zIndex: isActive ? 20000 : 0 }"></slot>
    <slot name="elmDText" class="noselect"></slot>
  </div>
</template>
<script>
  export default {
    name: 'Resizer',
    props: ['index', 'elmData', 'maxPos'],
    data () {
      return {
        isActive: false,
        isOpen: false,
        isEditText: false,
        isResizing: false,
        isMoving: false,
        handle: null,
        handles: ['tm', 'mr', 'bm', 'ml'],
        mousePos: { mouseX: 0, mouseY: 0 },
        fontSizePx: '14px',
        zIndex: 150000,
        cursor: 'pointer'
      }
    },
    mounted () {
      // this.elementCss.backgroundColor = 'rgba(255,255,0,0.2)'
      this.$bus.$on('activeElement', (args) => {
        this.isActive = (this.rptElementId === args.rptElementId)
        if (this.rptElementId === args.rptElementId) {
          // console.log(this.handle + ' >>> ' + this.elmData.text + ' >>> ' + this.rptElementId)
          this.zIndex = 2500
          this.cursor = 'move'
          /*
          this.elementCss.backgroundColor = 'rgba(255,255,0,0.2)'
          this.isActive = true
          this.isOpen = false
          this.isResizing = true
          this.isEditText = false
          this.isActive = true
          this.isOpen = false
          this.elementCss.zIndex = 500
          this.elementCss.backgroundColor = 'rgba(255,255,0,0.2)'
          this.elmData.top = Number(this.elmData.top)
          this.elmData.left = Number(this.elmData.left)
          this.elmData.width = Number(this.elmData.width)
          this.elmData.height = Number(this.elmData.height)
          this.elmData['rptElementId'] = this.rptElementId
          */
        } else {
          this.zIndex = 2000
          this.cursor = 'pointer'
          /*
          this.isActive = false
          this.isOpen = false
          this.isResizing = false
          this.isEditText = false
          this.elementCss.zIndex = 0
          */
        }
        this.$forceUpdate()
      })
    },
    ready: function () {
    },
    beforeDestroy: function () {
    },
    computed: {
      rptElementId () {
        return this.$root.getGUID()
      },
      resizerId () {
        return this.$root.getGUID()
      }
    },
    methods: {
      elementDown (e) {
        e.stopPropagation()
        this.mousePos = { mouseX: e.pageX, mouseY: e.pageY }
        this.isMoving = true
        this.zIndex = 3500
        this.mousePos.mouseX = e.pageX
        this.mousePos.mouseY = e.pageY
        document.onmouseup = this.elementUp
        document.onmousemove = this.elementMove
        this.activateElement()
      },
      elementMove (e) {
        let vm = this
        if (vm.isMoving) {
          const mouseX = vm.mousePos.mouseX
          const mouseY = vm.mousePos.mouseY
          const tmpDeltaX = mouseX - e.pageX
          const tmpDeltaY = mouseY - e.pageY
          let top = Number((vm.elmData.top * 96 - tmpDeltaY) / 96).toFixed(4)
          let left = Number((vm.elmData.left * 96 - tmpDeltaX) / 96).toFixed(4)
          // console.log(vm.maxPos)
          if (left < 0) {
            left = 0
          }
          // console.log(left + vm.elmData.width)
          // console.log(vm.maxPos)
          if ((left + vm.elmData.width) > vm.maxPos.left) {
            left = vm.maxPos.left - vm.elmData.width
          }
          // console.log(left)
          if (top < 0) {
            top = 0
          }
          // console.log(top + vm.elmData.height)
          if ((top + vm.elmData.height) > vm.maxPos.top) {
            top = vm.maxPos.top - vm.elmData.height
          }
          console.log('left = ' + left)
          console.log('top = ' + top)
          vm.elmData.left = left
          vm.elmData.top = top
        }
        this.mousePos.mouseX = e.pageX
        this.mousePos.mouseY = e.pageY
        this.$forceUpdate()
        this.activateElement()
      },
      elementUp (e) {
        this.isMoving = false
        document.onmouseup = null
        document.onmousemove = null
        this.mousePos = { mouseX: 0, mouseY: 0 }
      },
      handleDown (handle, e) {
        e.stopPropagation()
        this.handle = handle
        this.isResizing = true
        this.isMoving = false
        this.mousePos.mouseX = e.pageX
        this.mousePos.mouseY = e.pageY
        document.onmouseup = this.handleUp
        document.onmousemove = this.handleMove
      },
      handleMove (e) {
        if (this.isResizing) {
          const mouseX = this.mousePos.mouseX
          const mouseY = this.mousePos.mouseY
          const tmpDeltaX = mouseX - e.pageX
          const tmpDeltaY = mouseY - e.pageY
          switch (this.handle) {
            case 'tm':
              let top = Number((this.elmData.top * 96 - tmpDeltaY) / 96).toFixed(4)
              let height = Number((this.elmData.height * 96 + tmpDeltaY) / 96).toFixed(4)
              this.elmData.top = (top < 0) ? 0 : top
              if (top < 0) {
                top = 0
                height = this.elmData.height
              }
              this.elmData.top = top
              this.elmData.height = height
              break
            case 'mr':
              // this.elmData.left = Number((this.elmData.left * 96 - tmpDeltaX) / 96).toFixed(4)
              this.elmData.width = Number((this.elmData.width * 96 - tmpDeltaX) / 96).toFixed(4)
              break
            case 'bm':
              // this.elmData.top = Number((this.elmData.top * 96 - tmpDeltaY) / 96).toFixed(4)
              this.elmData.height = Number((this.elmData.height * 96 - tmpDeltaY) / 96).toFixed(4)
              break
            case 'ml':
              let width = Number((this.elmData.width * 96 + tmpDeltaX) / 96).toFixed(4)
              let left = Number((this.elmData.left * 96 - tmpDeltaX) / 96).toFixed(4)
              // this.elmData.left = (left < 0) ? 0 : left
              if (left < 0) {
                left = 0
                width = this.elmData.width
              }
              this.elmData.left = left
              this.elmData.width = width
              break
          }
        }
        this.mousePos.mouseX = e.pageX
        this.mousePos.mouseY = e.pageY
        this.activateElement()
      },
      handleUp (e) {
        this.handle = null
        this.isResizing = false
        document.onmouseup = null
        document.onmousemove = null
        this.mousePos = { mouseX: 0, mouseY: 0 }
      },
      activateElement () {
        // console.log('Resizer >>> activateElement() ')
        this.isActive = true
        // this.isResizing = true
        this.isOpen = false
        // this.elementCss.backgroundColor = 'rgba(255,255,0,0.2)'
        // console.log(this.elmData)
        this.elmData.top = Number(this.elmData.top)
        this.elmData.left = Number(this.elmData.left)
        this.elmData.width = Number(this.elmData.width)
        this.elmData.height = Number(this.elmData.height)
        this.elmData['rptElementId'] = this.rptElementId
        this.$bus.$emit('activeElement', this.elmData)
      },
      deActivateElement () {
        this.isActive = false
        this.isOpen = false
        // this.elementCss.zIndex = 0
        this.elementCss.backgroundColor = this.elmData.background_color
        this.$bus.$emit('activeElement', null)
      },
      onResize: function (x, y, w, h) {
        console.log('left = ' + this.elmData.left)
        console.log('x = ' + x)
        // console.log('y = ' + y)
        // console.log('w = ' + w)
        // console.log('h = ' + h)
        this.elmData.width = w / 96
        this.elmData.height = h / 96
        this.elmData.left = x / 96
        this.elmData.top = y / 96
        console.log('left = ' + this.elmData.left)
        this.activateElement()
      },
      onDrag: function (x, y) {
        this.elmData.left = x / 96
        this.elmData.top = y / 96
        this.activateElement()
      }
    }
  }
</script>
<style scoped>
  .resizer {
    touch-action: none;
    position: absolute;
    box-sizing: border-box;
  }

    .resizer .active {
      background-color: rgba(255,255,0,0.2);
    }

  .handle {
    box-sizing: border-box;
    position: absolute;
    width: 10px;
    height: 10px;
    background: #EEE;
    border: 1px solid #333;
  }

  .handle-tl {
    top: -10px;
    left: -10px;
    cursor: nw-resize;
  }

  .handle-tm {
    top: -10px;
    left: 50%;
    margin-left: -5px;
    cursor: n-resize;
  }

  .handle-tr {
    top: -10px;
    right: -10px;
    cursor: ne-resize;
  }

  .handle-ml {
    top: 50%;
    margin-top: -5px;
    left: -10px;
    cursor: w-resize;
  }

  .handle-mr {
    top: 50%;
    margin-top: -5px;
    right: -10px;
    cursor: e-resize;
  }

  .handle-bl {
    bottom: -10px;
    left: -10px;
    cursor: sw-resize;
  }

  .handle-bm {
    bottom: -10px;
    left: 50%;
    margin-left: -5px;
    cursor: s-resize;
  }

  .handle-br {
    bottom: -10px;
    right: -10px;
    cursor: se-resize;
  }

  @media only screen and (max-width: 768px) {
    [class*="handle-"]:before {
      content: '';
      left: -10px;
      right: -10px;
      bottom: -10px;
      top: -10px;
      position: absolute;
    }
  }
</style>



// WEBPACK FOOTER //
// Resizer.vue?1bb75e13